// Vuex Settings module mutations
import { hRemoveItemInArray } from '@/utils/helpers';
import {
  FILL_BUTTON_ICONS_LIST, FILL_WIDGET_ICONS_LIST, FILL_BEHAVIOR_TYPES_LIST,
  FILL_PACKAGE_DEFINITIONS, FILL_FAQ_LIST, ADD_SEARCH_KEYWORD_IN_FAQ_LIST,
  REMOVE_SEARCH_KEYWORD_IN_FAQ_LIST, CLEAR_SEARCH_KEYWORDS_IN_FAQ_LIST,
} from './mutations-types';

export default {
  [FILL_BUTTON_ICONS_LIST](state, payload) {
    const _state = state;
    _state.buttonIcons = payload.buttonIcons || [];
  },

  [FILL_WIDGET_ICONS_LIST](state, payload) {
    const _state = state;
    _state.widgetIcons = payload.widgetIcons || [];
  },

  [FILL_BEHAVIOR_TYPES_LIST](state, payload) {
    const _state = state;
    _state.behaviorTypes = payload.behaviorTypes;
  },

  [FILL_PACKAGE_DEFINITIONS](state, payload) {
    const _state = state;
    _state.packageDefinitions = payload.packageDefinitions;
  },

  [FILL_FAQ_LIST](state, payload) {
    const _state = state;
    _state.faqList = payload.faqList || [];
  },

  [ADD_SEARCH_KEYWORD_IN_FAQ_LIST](state, payload) {
    const _state = state;
    _state.keywordSearchInFaqList.push(payload);
  },

  [REMOVE_SEARCH_KEYWORD_IN_FAQ_LIST](state, payload) {
    const _state = state;
    hRemoveItemInArray(_state.keywordSearchInFaqList, payload);
  },

  [CLEAR_SEARCH_KEYWORDS_IN_FAQ_LIST](state) {
    const _state = state;
    _state.keywordSearchInFaqList = [];
  },
};
